import { render, staticRenderFns } from "./ImporterContainer.vue?vue&type=template&id=630e992c&scoped=true&"
import script from "./ImporterContainer.vue?vue&type=script&lang=js&"
export * from "./ImporterContainer.vue?vue&type=script&lang=js&"
import style0 from "./ImporterContainer.vue?vue&type=style&index=0&id=630e992c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e992c",
  null
  
)

export default component.exports